<template>
  <div
    class="fixed bg-white top-0 left-0 w-full mobile-navbar lg:hidden flex flex-col z-20"
    :class="{ 'mobile-menu-show': showMobile }"
  >
    <div class="container">
      <div class="top w-full py-4 flex items-center justify-between">
        <img
          class="w-[128px]"
          src="/logo/saraf-logo-dark.svg"
          alt="Saraf Logo"
        />
        <button @click="hideBurgerMenu">
          <i class="icon-close text-dark block text-[28px]"></i>
        </button>
      </div>
      <ul class="flex flex-col space-y-2 divide-y divide-gray/20">
        <li
          v-for="(link, idx) in links"
          :key="idx"
          class="pt-2 leading-130"
          @click="hideBurgerMenu"
        >
          <LocalizedLink
            :to="link.url"
            class="text-base text-dark font-semibold"
          >
            {{ $t(link.title) }}
          </LocalizedLink>
        </li>
      </ul>
    </div>
    <div class="w-full flex items-center gap-2 mt-auto py-6 px-3 bg-gray/10">
      <LocalizedLink to="/auth/login" class="w-1/2">
        <BaseButton
          :text="$t('landing.links.sign_in')"
          size="sm"
          variant="secondary"
          class="w-full flex-y-center px-[12px] flex-y-center !justify-center"
        />
      </LocalizedLink>
      <LocalizedLink to="/auth/register" class="w-1/2">
        <BaseButton
          :text="$t('landing.links.sign_up')"
          size="sm"
          class="w-full flex-y-center px-[12px] flex-y-center !justify-center"
        />
      </LocalizedLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseButton from "@/modules/Landing/components/Base/Button/Button.vue";
import { links } from "@/data";

interface Props {
  showMobile: boolean;
}
interface Emits {
  (e: "hideMobileMenu"): void;
}
defineProps<Props>();
const emit = defineEmits<Emits>();

const hideBurgerMenu = () => {
  emit("hideMobileMenu");
};
</script>

<style scoped>
.mobile-navbar {
  height: 100vh;
  z-index: 99999;
  transform: translateX(-100%);
  transition: transform 0.2s ease-in-out;
}

.mobile-menu-show {
  transform: translateX(0%);
  transition: transform 0.2s ease-in-out;
}
</style>
